<div class="clug-form-modal" [formGroup]="userForm">
  <div class="clug-form-modal-loader" *ngIf="loading">
    <div class="auth-spinner" aria-label="Loading"></div>
  </div>

  <div class="modal-head">
    <div class="title-block">
      <h2>Add Candidate</h2>
      <span class="sub">Onboard a new contractor. Step through identity, address, VAT and bank details.</span>
    </div>
    <button type="button" class="close-btn" title="Close" (click)="onClose()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="modal-subtabs">
    <button type="button" class="modal-subtab" [class.active]="activeSubpanel === 'identity'"
      (click)="setSubpanel('identity')">
      <i class="bi bi-person"></i>Identity
    </button>
    <button type="button" class="modal-subtab" [class.active]="activeSubpanel === 'address'"
      (click)="setSubpanel('address')">
      <i class="bi bi-geo-alt"></i>Address
    </button>
    <button type="button" class="modal-subtab" [class.active]="activeSubpanel === 'vat'" (click)="setSubpanel('vat')">
      <i class="bi bi-receipt"></i>VAT
    </button>
    <button type="button" class="modal-subtab" [class.active]="activeSubpanel === 'ltd'" (click)="setSubpanel('ltd')">
      <i class="bi bi-bank"></i>Limited company
    </button>
    <button type="button" class="modal-subtab" [class.active]="activeSubpanel === 'additional'"
      (click)="setSubpanel('additional')">
      <i class="bi bi-sliders"></i>Additional
    </button>
  </div>

  <div class="modal-body tight">

    <!-- Identity -->
    <div *ngIf="activeSubpanel === 'identity'">
      <div class="form-section">
        <div class="form-section-head">
          <span class="title">
            <span class="ico"><i class="bi bi-person"></i></span>Identity
          </span>
          <span class="req-pill">Required</span>
        </div>
        <div class="grid-2">
          <div class="field tight">
            <label>First name <span class="req">*</span></label>
            <input type="text" class="input-form" formControlName="first_name" placeholder="e.g. Brian"
              [class.invalidField]="userForm.controls.first_name.errors && userForm.controls.first_name.touched" />
          </div>
          <div class="field tight">
            <label>Last name <span class="req">*</span></label>
            <input type="text" class="input-form" formControlName="last_name" placeholder="e.g. Smith"
              [class.invalidField]="userForm.controls.last_name.errors && userForm.controls.last_name.touched" />
          </div>
          <div class="field tight full">
            <label>Email <span class="req">*</span></label>
            <input type="email" class="input-form" formControlName="email" placeholder="brian@example.com"
              [class.invalidField]="userForm.controls.email.errors && userForm.controls.email.touched" />
            <span class="hint">Used to send invites, reminders and timesheet links.</span>
          </div>
          <div class="field tight full">
            <div class="toggle-row">
              <div class="meta">
                <span class="label">Send invite email</span>
                <span class="sub">Email them a link to set their password and complete onboarding.</span>
              </div>
              <button type="button" class="switch" [class.on]="!!userForm.value.send_invite"
                (click)="toggleSendInvite()" [attr.aria-pressed]="!!userForm.value.send_invite"></button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Address -->
    <div *ngIf="activeSubpanel === 'address'">
      <div class="form-section">
        <div class="form-section-head">
          <span class="title">
            <span class="ico"><i class="bi bi-geo-alt"></i></span>Address
          </span>
          <span class="req-pill">Required</span>
        </div>
        <div class="grid-2">
          <div class="field tight full">
            <label>Address line 1 <span class="req">*</span></label>
            <input type="text" class="input-form" formControlName="address_1" placeholder="Street and number"
              [class.invalidField]="userForm.controls.address_1.errors && userForm.controls.address_1.touched" />
          </div>
          <div class="field tight full">
            <label>Address line 2</label>
            <input type="text" class="input-form" formControlName="address_2" placeholder="Apartment, suite, etc." />
          </div>
          <div class="field tight">
            <label>Post code</label>
            <input type="text" class="input-form" formControlName="post_zip_code" placeholder="e.g. SW1A 1AA" />
          </div>
          <div class="field tight">
            <label>Country</label>
            <input type="text" class="input-form" formControlName="country" placeholder="e.g. United Kingdom" />
          </div>
        </div>
      </div>
    </div>

    <!-- VAT -->
    <div *ngIf="activeSubpanel === 'vat'">
      <div class="form-section">
        <div class="form-section-head">
          <span class="title">
            <span class="ico"><i class="bi bi-receipt"></i></span>VAT
          </span>
          <span class="req-pill opt">Optional</span>
        </div>
        <div class="grid-2">
          <div class="field tight">
            <label>VAT applicable?</label>
            <div class="seg">
              <button type="button" [class.on]="userForm.value.is_vat_applicable !== 1" (click)="setVat(0)">No</button>
              <button type="button" [class.on]="userForm.value.is_vat_applicable === 1" (click)="setVat(1)">Yes</button>
            </div>
          </div>
          <div class="field tight">
            <label>VAT code</label>
            <input type="text" class="input-form" formControlName="vat_code" placeholder="e.g. GB123456789"
              [class.disabled]="userForm.value.is_vat_applicable !== 1"
              [attr.disabled]="userForm.value.is_vat_applicable !== 1 ? '' : null" />
          </div>
        </div>
      </div>
    </div>

    <!-- Limited company -->
    <div *ngIf="activeSubpanel === 'ltd'">
      <div class="form-section">
        <div class="form-section-head">
          <span class="title">
            <span class="ico"><i class="bi bi-bank"></i></span>Limited company &amp; bank
          </span>
          <span class="req-pill opt">Optional</span>
        </div>
        <div class="grid-2">
          <div class="field tight">
            <label>Company / umbrella name</label>
            <input type="text" class="input-form" formControlName="limited_company_name"
              placeholder="e.g. BS Contracting Ltd" />
          </div>
          <div class="field tight">
            <label>Company email</label>
            <input type="email" class="input-form" formControlName="limited_company_email" placeholder="invoices@…" />
          </div>
          <div class="field tight full">
            <label>Company address</label>
            <textarea class="input-form" rows="2" formControlName="limited_company_address"></textarea>
          </div>
          <div class="field tight full">
            <label>Bank address</label>
            <textarea class="input-form" rows="2" formControlName="limited_company_bank_address"></textarea>
          </div>
          <div class="field tight">
            <label>Bank name</label>
            <input type="text" class="input-form" formControlName="limited_company_bank_name"
              placeholder="e.g. Barclays" />
          </div>
          <div class="field tight">
            <label>Bank account name</label>
            <input type="text" class="input-form" formControlName="limited_company_bank_account_name" />
          </div>
          <div class="field tight">
            <label>Sort code</label>
            <input type="text" class="input-form" formControlName="limited_company_sort_code" placeholder="00-00-00" />
          </div>
          <div class="field tight">
            <label>Account number</label>
            <input type="text" class="input-form" formControlName="limited_company_account_number" />
          </div>
          <div class="field tight">
            <label>SWIFT / BIC</label>
            <input type="text" class="input-form" formControlName="limited_company_swift_code" />
          </div>
        </div>
      </div>
    </div>

    <!-- Additional -->
    <div *ngIf="activeSubpanel === 'additional'">
      <div class="form-section">
        <div class="form-section-head">
          <span class="title">
            <span class="ico"><i class="bi bi-sliders"></i></span>Additional details
          </span>
          <span class="req-pill opt">Optional</span>
        </div>
        <div class="grid-2">
          <div class="field tight">
            <label>Identifier</label>
            <input type="text" class="input-form" formControlName="identifier" placeholder="Internal reference" />
          </div>
          <div class="field tight">
            <label>SSN / NI</label>
            <input type="text" class="input-form" formControlName="ssn" />
          </div>
          <div class="field tight">
            <label>Registration number</label>
            <input type="text" class="input-form" formControlName="registration_number" />
          </div>
          <div class="field tight">
            <label>Payment terms</label>
            <div class="select-wrap">
              <select class="input-form" formControlName="payment_terms">
                <option value="">Select payment terms</option>
                <option *ngFor="let term of ['7','14','15','30','35','45','60','90']" [value]="term">
                  {{ term }} days
                </option>
              </select>
            </div>
          </div>
          <div class="field tight">
            <label>Currency</label>
            <div class="select-wrap">
              <select class="input-form" formControlName="currency_format">
                <option value="">Select currency</option>
                <option *ngFor="let cf of dataSharedService.currencyFormatList" [value]="cf">{{ cf }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-error" *ngIf="error">
      <i class="bi bi-exclamation-triangle-fill"></i>
      <span>{{ error }}</span>
    </div>
  </div>

  <div class="modal-foot">
    <div class="left">
      <i class="bi bi-info-circle"></i>
      <span>Required fields marked <span class="req">*</span>. Save to create the record.</span>
    </div>
    <div class="right">
      <button type="button" class="btn btn-secondary" (click)="onClose()">Cancel</button>
      <button type="submit" class="btn btn-primary" [disabled]="loading || !userForm.valid" (click)="onSubmit()">
        <i class="bi bi-check-lg"></i>Save
      </button>
    </div>
  </div>
</div>